import { render, staticRenderFns } from "./StipendiatSborStory.vue?vue&type=template&id=a9246a02&scoped=true&"
import script from "./StipendiatSborStory.vue?vue&type=script&lang=js&"
export * from "./StipendiatSborStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9246a02",
  null
  
)

export default component.exports